import { CHECKLIST_ITEM_TYPE } from 'src/constants/tasksV2';

export default {
    id: 16,
    type: CHECKLIST_ITEM_TYPE.SCHEDULE_REMINDER,
    manifestKey: 'SCHEDULE_REMINDER',

    try_it: {
        button_label: 'Schedule Reminder',
        cell_component_import: {
            from: 'src/pages/dashboard/tables/AllLeadTable/TaskChecklistField',
            named: 'ScheduleReminderCell',
        },
        prefill: {
            completion_state: 'YES',
            response_payload: { scheduled_for: '2026-06-01T09:00:00Z' },
        },
    },
    pre_flight_diff: [
        'Date/time picker dialog opens — user picks a future datetime',
        'Checklist item: PENDING → YES',
        'scheduled_for stored in response_payload',
        '⚠ V2 path gap: 9am daily-email dispatcher NOT wired — reminder stored but no email fires on due date',
        'Out-of-scope ticket #5',
    ],
    has_step2_throttle: false,
    validation_laboratory: null,
};
